import SvgIcon from "@mui/material/SvgIcon";

function XIcon(props) {
  return (
    <SvgIcon {...props} viewBox="0 0 24 24">
      <path d="M22.675 2h-2.82L13.295 9.89 7.12 2H.5l8.79 11.474L.5 22h2.821l7.214-8.164L16.88 22h6.62l-9.25-12.083L22.675 2z" />
    </SvgIcon>
  );
}
export default XIcon;
